
  import { ValidationError } from '@/entities/validation';
  import { DropdownField } from '@/ui/components/form/DropdownField';
  import { InputField } from '@/ui/components/form/InputField';
  import { validationError } from '@/ui/dictionary';
  import { ScoreTriggerEditable } from '@/ui/DTO';
  import { t } from '@/ui/i18n/i18n';
  import { computed, defineComponent } from 'vue';

  interface ScoreTriggerProps {
    value: ScoreTriggerEditable;
    errors: ValidationError[];
    title: string;
  }

  export default defineComponent<ScoreTriggerProps>({
    name: 'ScoreTrigger',
    components: { InputField, DropdownField },
    props: ['value', 'errors', 'title'],
    setup(props) {
      const errorMsgs = computed(() => props.errors.filter(error => error.field.startsWith('scoreTrigger')).map(error => {
        if (error.type !== 'unknown') {
          const label = error.field === 'scoreTrigger.from' ? t('From') : t('To');
          return validationError(`"${label}"`, error);
        }

        return t('issue-template.score-trigger.validation');
      }));
      const hasFromError = computed(() => props.errors.some(error => error.field === 'scoreTrigger.from' || error.field === 'scoreTrigger'));
      const hasToError = computed(() => props.errors.some(error => error.field === 'scoreTrigger.to' || error.field === 'scoreTrigger'));

      const operatorOptions = [
        { value: '<', label: t('common.operators.below') },
        { value: '>', label: t('common.operators.above') },
        { value: 'between', label: t('common.operators.between') },
      ];

      const sanitizeFloat = (value: string) => value.replace(',', '.');

      const updateOperator = (operator: ScoreTriggerEditable['operator']) => {
        props.value.operator = operator;

        //reset the value to avoid validation errors in hidden fields
        if (operator === '>') {
          props.value.to = '100';
        }
        if (operator === '<') {
          props.value.from = '0';
        }
      };

      return {
        operatorOptions,
        hasFromError,
        hasToError,
        errorMsgs,
        sanitizeFloat,
        updateOperator,
      };
    },
  });
